import React, { useEffect, useState } from "react";
import Image from "next/image";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
import KnowMore from "@/components/ui/know-more";
import SubscribeButton from "@/components/ui/subscribe-button";
import Link from "next/link";
import { AnimatePresence, m } from "framer-motion";
export default function Slider1({ data = [] }) {
  // const [showDesc,setShowDesc] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    data?.length > 0 && (
      <div className="bg-[#E9E7DE] pt-12 z-[100] relative">
        <div className="flex flex-col w-full ">
          <Carousel
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            className="featureCarousel w-full my-8"
            navigation={false}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
            }}
            pagination={false}
            showNavProject={true}
            showNavAbove={false}
            setCurrentSlide={setCurrentSlide}
          >
            {data.map((post, key) => (
              <SwiperSlide key={"Post" + key}>
                <Post data={post} />
              </SwiperSlide>
            ))}
          </Carousel>
          {data[0]?.title && data[0]?.description && (
            <div className="flex flex-row w-full lg:min-h-[250px] md:min-h-[200px] py-8 md:px-8 px-4">
              <AnimatePresence mode="wait">
                <m.div
                  initial={{ opacity: 0, y: -50 }}
                  animate={{ opacity: 100, y: 0 }}
                  exit={{ opacity: 0, y: -50 }}
                  transition={{ duration: 0.3 }}
                  className="flex md:flex-row flex-col w-full gap-8 bg-inherit md:items-center md:justify-around"
                >
                  <p className="font-havletica font-light lg:text-[25px] md:text-xl text-lg lg:max-w-[359px] text-darkGrey/80">
                    {data[0]?.title}
                  </p>

                  <div
                    dangerouslySetInnerHTML={{
                      __html: data[0]?.description,
                    }}
                    className="[&>*]:text-sm text-darkGrey/70 [&>*]:font-light bg-inherit md:max-w-[446px]"
                  ></div>
                </m.div>
              </AnimatePresence>
            </div>
          )}
        </div>
      </div>
    )
  );
}
const Post = ({ data }) => {
  const { image } = data;
  return (
    <div className="w-full lg:h-[90vh] md:h-[400px] h-[350px] flex flex-col items-center justify-center relative">
      <Image
        src={image?.data?.attributes?.url}
        alt={image?.data?.attributes?.name}
        sizes="(max-width: 479px) 500px, 800px"
        fill
        className="w-full h-full lg:object-cover object-cover"
      />
    </div>
  );
};
